/**
 * MATRIX1 safe bootstrap.
 * Removes stale loader locks once without observers, polling, request interception,
 * history patching, or recurring timers.
 */
(() => {
  'use strict';
  if (window.__G21_MATRIX1_SAFE_BOOT__) return;
  window.__G21_MATRIX1_SAFE_BOOT__ = true;

  const unlockProductPage = () => {
    [document.documentElement, document.body].forEach((element) => {
      if (!element) return;
      element.classList.remove('g21-product-is-loading', 'g21-is-loading', 'is-loading', 'loading');
      element.style.removeProperty('overflow');
      element.style.removeProperty('pointer-events');
      element.style.removeProperty('opacity');
      element.removeAttribute('aria-busy');
    });

    document.querySelectorAll(
      '#g21-product-loader, #g21-aurora-loader-overlay, .g21-product-loader, [data-g21-product-loader]'
    ).forEach((loader) => loader.remove());
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', unlockProductPage, { once: true });
  } else {
    unlockProductPage();
  }
  window.addEventListener('pageshow', unlockProductPage, { once: true });

  window.G21Matrix1SafeBoot = Object.freeze({
    installed: true,
    navigationTemporarilyDisabled: false,
    refresh: unlockProductPage
  });
})();
